import type { FC } from 'react';
import React from 'react';

import { BadgeList } from '../../../../../../../common/components/BadgeList';
import { useWidget } from '../../../../../../../contexts/widgets';
import styles from './Badges.scss';

export const Badges: FC = () => {
  const { site, computed, handlers } = useWidget();

  const { navigateToViewedMember } = handlers;
  const { badgesSettings } = computed;
  const { isSocial } = site;

  return (
    <div className={styles.container}>
      <BadgeList
        {...badgesSettings}
        maxRows={1}
        onClickMore={isSocial ? navigateToViewedMember : undefined}
        onBadgeClick={isSocial ? navigateToViewedMember : undefined}
      />
    </div>
  );
};
